import { Component, OnInit } from '@angular/core';
import { ProductListConfigService } from 'gung-standard';

@Component({
    selector: 'ref-ref-products',
    template: '<lib-filter-list #productList [configService]="productListConfigService"></lib-filter-list>',
    styleUrls: ['./ref-products.component.scss'],
    standalone: false
})
export class RefProductsComponent implements OnInit {
  constructor(public productListConfigService: ProductListConfigService) {}

  ngOnInit() {}
}
